{"version":"1.0.0","gitHash":"6ac90f58","environment":"prod"}